import { CREATE_MUTATE_INVOICE } from "api/dataProviderTypes";
import useGetInvoices from "hooks/queries/useGetInvoices";
import { useMutation } from "react-query";
import { createInvoice } from "services/invoices";

const useMutateCreateInvoice = (payload?: any) => {
  const { refetch } = useGetInvoices(payload?.patientId);
  const result = useMutation(
    CREATE_MUTATE_INVOICE,
    (data: any) => createInvoice(data),
    {
      onSuccess: () => {
        refetch();
      },
    }
  );

  return result;
};

export default useMutateCreateInvoice;
